export type PillarType = {
  id: string;
  node: number;
  label: string;
  code: string;
  prefix: string;
  description: string;
  iconBg: string;
  borderColor: string;
  icon: string;
  iconShadow: string;
  children: {
    id: string;
    node: number;
    label: string;
    count: string;
    icon: string;
    description: string;
  }[];
}[];
export type PillarNavigationType = {
  code: string;
  description: string;
  graphics: {
    iconbg: string;
    bordercolor: string;
    icon: string;
    iconshadow: string;
  };
  id: string;
  is_core: boolean;
  subdomains: {
    id: string;
    description: string;
    title: string;
    knowledge_areas: {
      id: string;
      description: string;
      title: string;
      knowledge_topics: {
        id: string;
        description: string;
        title: string;
      }
    }
  };
  title: string;
};
export type PillarTypeDetail = {
  code: string;
  description: string;
  graphics: {
    iconbg: string;
    bordercolor: string;
    icon: string;
    iconshadow: string;
  };
  id: string;
  is_core: boolean;
  ordinal: number;
  prefix: string;
  subdomains: Array<{
    id: string;
    description: string;
    title: string;
    knowledge_areas: Array<{
      id: string;
      description: string;
      title: string;
      knowledge_topics: Array<{
        id: string;
        description: string;
        title: string;
      }>
    }>
  }>;
  title: string;
};
export const EmptyPillarTypeDetail = {
  code: '',
  prefix: '',
  description: '',
  graphics: {
    iconbg: '',
    bordercolor: '',
    icon: '',
    iconshadow: '',
  },
  id: '',
  is_core: false,
  ordinal: 0,
  subdomains: [{
    id: '',
    description: '',
    title: '',
    knowledge_areas: [{
      id: '',
      description: '',
      title: '',
      knowledge_topics: [{
        id: '',
        description: '',
        title: '',
      }]
    }]
  }],
  title: ''
};
export const EmptyPillarNavigation = {
  code: '',
  description: '',
  graphics: {
    iconbg: '',
    bordercolor: '',
    icon: '',
    iconshadow: '',
  },
  id: '',
  is_core: false,
  subdomains: {
    id: '',
    description: '',
    title: '',
    knowledge_areas: {
      id: '',
      description: '',
      title: '',
      knowledge_topics: {
        id: '',
        description: '',
        title: '',
      }
    }
  },
  title: ''
};